import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook to preserve current search parameters when navigating to a new URL
 * @returns The URL with current search parameters appended
 */
export function usePreserveSearchParams() {
  const [searchParams] = useSearchParams();

  const getUrlWithSearchParams = useCallback(
    (baseUrl: string, paramsToRetain?: string[]): string => {
      if (!paramsToRetain || paramsToRetain.length === 0) {
        const currentSearch = searchParams.toString();
        if (currentSearch) {
          return `${baseUrl}?${currentSearch}`;
        }
        return baseUrl;
      }

      const filteredParams = new URLSearchParams();
      paramsToRetain.forEach(paramName => {
        const value = searchParams.get(paramName);
        if (value !== null) {
          filteredParams.set(paramName, value);
        }
      });

      const filteredSearch = filteredParams.toString();
      if (filteredSearch) {
        return `${baseUrl}?${filteredSearch}`;
      }
      return baseUrl;
    },
    [searchParams]
  );

  return { getUrlWithSearchParams };
}
